// extracted by mini-css-extract-plugin
module.exports = {"Phone":"styles-module--Phone--8Xdu7","body":"styles-module--body--jsMBQ","content":"styles-module--content--2RTgi","text":"styles-module--text--1HAxt"};